import Modal from './container'

export default Modal
